export default __webpack_public_path__ + "static/media/horizontal-fill-gold.6a37fc57.svg";